module.exports = __webpack_public_path__ + "img/empty.d5121c19.svg";